import { RoleTypes } from '../../core-module/helpers/RoleHelper';

export const ORGANIZATION_UITGEKOOKT = 'uitgekookt';
export const ORGANIZATION_STICHTING = 'stichting';
export const ORGANIZATION_ZELFSTANDIG = 'zelfstandig';

export const ORGANIZATIONS = [
  ORGANIZATION_UITGEKOOKT,
  ORGANIZATION_STICHTING,
  ORGANIZATION_ZELFSTANDIG
] as const;

export type Organization =
  | typeof ORGANIZATION_UITGEKOOKT
  | typeof ORGANIZATION_STICHTING
  | typeof ORGANIZATION_ZELFSTANDIG;

export type SideBarItem = {
  icon: string;
  url: string;
  label: string;
  role?: RoleTypes;
  excludeRoles: string[];
  onlyShowForOrganizations: Organization[];
  exact: boolean;
  next: boolean;
};

export const isOrganization = (value: string): value is Organization =>
  (ORGANIZATIONS as readonly string[]).includes(value);
